import { Button, Flex, Icon } from '@chakra-ui/react'
import { useTranslation } from '@infraloop/i18n'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

const NAV_PROPS = {
  variant: 'ghost',
  size: 'sm',
  h: '34px',
  px: '12px',
  color: 'gray.500',
  fontWeight: 'semibold',
} as const

const UserListPagination = ({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
}: {
  /** Whether a previous page exists (there's a page before the current one). */
  hasPrev: boolean
  /** Whether a next page exists (the current page returned a keyset cursor). */
  hasNext: boolean
  /** Go to the previous page. */
  onPrev: () => void
  /** Go to the next page. */
  onNext: () => void
}) => {
  const { t } = useTranslation()

  return (
    <Flex align="center" justify="flex-end" gap="2px" mt="18px" flexWrap="wrap">
      <Button {...NAV_PROPS} disabled={!hasPrev} onClick={onPrev} data-testid="user-list-prev">
        <Icon as={LuChevronLeft} boxSize="16px" />
        {t('hatsuly.userList.prevPage')}
      </Button>
      <Button {...NAV_PROPS} disabled={!hasNext} onClick={onNext} data-testid="user-list-next">
        {t('hatsuly.userList.nextPage')}
        <Icon as={LuChevronRight} boxSize="16px" />
      </Button>
    </Flex>
  )
}

export default UserListPagination
